export const iOSUrl = "https://apps.apple.com/app/id6449183570?platform=iphone";
export const androidUrl =
  "https://play.google.com/store/apps/details?id=app.recipelog.www.twa";
export { default as sessionStorageKeys } from "./sessionStorageKeys";
